import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Table, TableBody, TableHead, TableRow } from "@mui/material";
import { TableCell } from "@material-ui/core";
import { getChlorinationStationDetails } from "../ProductionLine/services";
import dayjs from "dayjs";

const Chlorination = ({ setchlorinationPopup, batchId }) => {
  const [chlorinationData, setChlorinationData] = useState([]);

  useEffect(() => {
    handleGetChlorinationData();
  }, [batchId]);
  
  const handleGetChlorinationData = async () => {
    try {
      const resp = await getChlorinationStationDetails(batchId);
      if (resp.status == 200 || resp.status == 201) {
        setChlorinationData(resp.data.payload);
      }
    } catch (error) {
      setChlorinationData([]);
      console.log("handlesubmit", error);
    }
  };
  return (
    <>
      <div className="modal-container" style={{ height: "40vh", top: "35vh" }}>
        <div className="modal-header">
          <div className="modal-title">CHLORINATION PROCESS SHEET</div>
          <div
            onClick={() => setchlorinationPopup(false)}
            style={{ cursor: "pointer" }}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="modal-table-wrapper">
          <div
            style={{
              width: "100%",
              overflow: "auto",
              maxHeight: "400px",
            }}
            className="gloves-report-data"
          >
            <Table className="dipping-params">
              <TableHead>
                <TableRow>
                  <TableCell>Batch No.</TableCell>
                  <TableCell>Receipe</TableCell>
                  <TableCell>Start Time</TableCell>
                  <TableCell>End Time</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="gloves-report-body">
                {chlorinationData?.map((e) => {
                  return (
                    <TableRow>
                      <TableCell>
                        {e.batch_type ? e.batch_type : "--"}
                      </TableCell>
                      <TableCell>{e.recipe ? e.recipe : "--"}</TableCell>
                      <TableCell>
                        {e
                          ? e?.cycle_start_time
                            ? dayjs(e.cycle_start_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>
                        {e
                          ? e?.cycle_end_time
                            ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
      <div
        className="modal-overlay"
        onClick={() => setchlorinationPopup(false)}
      ></div>
    </>
  );
};
export default Chlorination;
